import $cookies from '@/plugins/vueCookies'

export default [
  {
    name: 'main',
    path: '/',
    meta: {
      layout: 'DefaultLayoutFluid',
      requireSignin: false,
      ui: {
        newHeader: true,
      },
    },
    beforeEnter(to, from, next) {
      const landing = $cookies.get('landing')
      if (!!landing) {
        return next({ name: 'landing', params: { section: landing } })
      }
      next()
    },
    component() {
      return import('@/pages/main/Main.vue')
    },
  },
]
